// Tiny pub/sub so non-component helpers can raise a message in the task pane's NoticeBar.
const listeners = new Set();

export function showNotice(message) {
  listeners.forEach((listener) => listener(message));
}

export function subscribeToNotices(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
